import type { FC } from "react";
/**
 * a simple item component
 * @returns {any}
 * @constructor
 * @param value
 * @param query
 * @param children the parsed content
 */
import type { IAutoCompleteItemComponentProps } from "./types";
export const SimpleItem: FC<IAutoCompleteItemComponentProps> = function SimpleItem({ value, query, children }) {
    return <a style={{ color: "#2B3D52", padding: "5px 20px" }}>{children}</a>;
};
export const KeywordItem: FC<IAutoCompleteItemComponentProps> = function SimpleItem({ value, query, children }) {
    return (
        <a style={{ color: "#2B3D52", padding: "5px 20px" }}>
            <i
                className="sw-icon-keywords-list"
                style={{ fontSize: 12, marginRight: 10 }}
            />
            {children}
        </a>
    );
};
/**
 * Default Emphasis Component
 * @param value
 * @returns {any}
 * @constructor
 */
export const StrongEmphasisComponent: FC<IAutoCompleteItemComponentProps> = function StrongEmphasisComponent({
    value,
    query,
    children,
}) {
    return <strong>{children}</strong>;
};
